import { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (!token) {
            setLoading(false);
            return;
        }

        try {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000;
            if (decodedToken.exp < currentTime) {
                localStorage.removeItem('token');
                setLoading(false);
                navigate('/login');
            } else {
                setIsAuthenticated(true);
                setUserRole(decodedToken.role === 1 ? 'admin' : 'operateur');
                setLoading(false);
            }
        } catch (error) {
            console.error('Invalid token:', error);
            localStorage.removeItem('token');
            setLoading(false);
            navigate('/login');
        }
    }, [navigate]);

    const login = (token) => {
        localStorage.setItem('token', token);
        const decodedToken = jwtDecode(token);
        setIsAuthenticated(true);
        setUserRole(decodedToken.role === 1 ? 'admin' : 'operateur');

        if (decodedToken.role === 1) {
            navigate('/dashboard');
        } else {
            navigate('/dashboard/ListSimulation');
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        setUserRole(null);
        navigate('/login');
    };

    // Affiche un loading pendant que l'état d'authentification est vérifié.
    if (loading) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src='/loading.svg' alt='loading' style={{ width: 70, height: 70 }} />
            </div>
        );
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, userRole }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
